import React from 'react'

export default function IconAdd() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 mx-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{ color: "#a0a0a0" }} >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
    )
}
